import { ingestAPIObject } from "../utils/api";
export class GrowerDTO {
    constructor(jsonData) {
        ingestAPIObject(this, jsonData);
    }
}
